module.exports = "<div class=\"container mat-headline t-center\">\n  {{ 'listing_jobs_message' | translate }}\n</div>\n"